var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ValueValidationError = /** @class */ (function (_super) {
    __extends(ValueValidationError, _super);
    function ValueValidationError(value, messages, row, rowPos) {
        var _this = _super.call(this, "Invalid #".concat(rowPos, " row in CSV: ").concat(JSON.stringify(row))) || this;
        _this.value = value;
        _this.messages = messages;
        _this.row = row;
        _this.rowPos = rowPos;
        return _this;
    }
    return ValueValidationError;
}(Error));
export { ValueValidationError };
//# sourceMappingURL=ValueValidationError.js.map